import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Check } from "lucide-react";
import { PageHero, Reveal } from "@/components/site/Reveal";
import { api, euro } from "@/lib/api";
import usePageMeta from "@/hooks/usePageMeta";

export const FormuleCard = ({ f }) => (
  <div data-testid={`formule-card-${f.slug}`}
    className={`relative flex h-full flex-col rounded-lg border p-8 transition-transform duration-300 hover:-translate-y-1 ${f.mise_en_avant ? "border-[#0F2840] bg-[#0F2840] text-white" : "border-[#0F2840]/15 bg-white"}`}>
    {f.mise_en_avant && <span className="absolute -top-3 left-8 rounded-full bg-[#D82C2C] px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-white">La plus choisie</span>}
    <h3 className="font-display text-2xl font-semibold">{f.nom}</h3>
    <p className={`mt-2 text-sm ${f.mise_en_avant ? "text-white/75" : "text-slate-600"}`}>{f.description}</p>
    <p className="mt-6 flex items-baseline gap-1">
      {f.periode === "intervention" && <span className="text-sm">dès</span>}
      <span className="font-display text-4xl font-semibold" data-testid={`formule-prix-${f.slug}`}>{euro(f.prix)}</span>
      <span className={`text-sm ${f.mise_en_avant ? "text-white/70" : "text-slate-500"}`}>/ {f.periode}</span>
    </p>
    <ul className="mt-6 flex-1 space-y-3 text-sm">
      {(f.inclus || []).map((x) => (
        <li key={x} className="flex gap-2"><Check className={`mt-0.5 h-4 w-4 shrink-0 ${f.mise_en_avant ? "text-[#ff8080]" : "text-[#D82C2C]"}`} />{x}</li>
      ))}
    </ul>
    <Link to={`/devis?formule=${encodeURIComponent(f.id)}`} data-testid={`formule-cta-${f.slug}`}
      className={`mt-8 rounded-full py-3 text-center text-sm font-bold transition-colors ${f.mise_en_avant ? "bg-[#D82C2C] text-white hover:bg-[#b82323]" : "border border-[#0F2840] text-[#0F2840] hover:bg-[#0F2840] hover:text-white"}`}>
      Choisir cette formule
    </Link>
  </div>
);

export default function Formules() {
  usePageMeta("Formules et abonnements", "Formules Tranquillité, Formule militaire et prestations à la carte de la Conciergerie Familly 29 à Brest.");
  const { data = [], isLoading } = useQuery({ queryKey: ["formules"], queryFn: () => api.get("/public/formules").then((r) => r.data) });
  return (
    <>
      <PageHero testid="formules-hero" eyebrow="Militaire en mission" title="Une formule pour chaque situation." text="Absence prolongée, mission militaire, location saisonnière ou besoin ponctuel : choisissez la sérénité." image="/images/maison.jpg" />
      <section className="mx-auto max-w-7xl px-5 py-24 lg:px-8">
        {isLoading ? <p className="text-sm text-slate-500">Chargement…</p> : (
          <div className="grid gap-6 md:grid-cols-3" data-testid="formules-list">
            {data.map((f, i) => <Reveal key={f.id} delay={i * 0.08}><FormuleCard f={f} /></Reveal>)}
          </div>
        )}
        <p className="mt-10 text-xs text-slate-500">Tarifs indicatifs en euros, TVA non applicable (franchise en base). Un devis personnalisé vous est remis avant toute prestation – voir nos <a href="/cgv" className="underline">CGV</a>.</p>
      </section>
    </>
  );
}
